import { getFeatureToggleClient } from 'infra/featureToggles'

export default function isJobNotesEnabled(): boolean {
  return getFeatureToggleClient().variation('Portals.JobNotesEnabled', false)
}
